import { namespaceConfigurationUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import {
  CreateMachineGroupPayload,
  MachineGroup,
} from "@src/types/namespace-configuration";
import axios, { isAxiosError } from "axios";
import { buildAxiosAuthenticationHeaders } from "@src/cloud-connect/api/util/build-axios-authentication-headers";

export const postCreateMachineGroup = async (
  namespace: string,
  payload: CreateMachineGroupPayload,
): Promise<MachineGroup> => {
  const url = namespaceConfigurationUrlEnvVar();
  const headers = buildAxiosAuthenticationHeaders();

  try {
    const response = await axios.post<MachineGroup>(
      `${url}/api/v1/ns/${namespace}/machine-groups`,
      payload,
      { headers },
    );

    return response.data;
  } catch (err) {
    if (isAxiosError(err)) {
      console.error("Axios error:", err);
      throw new Error(
        err.response?.data?.detail ||
          err.response?.data?.message ||
          "Failed to create machine group. Please try again later.",
      );
    }

    throw new Error(
      "An unexpected error occurred while creating machine group.",
    );
  }
};
